interface FormApiResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

export interface FormResult {
  ok: boolean;
  message: string;
}

/**
 * Submits a form to the Readdy form endpoint using
 * application/x-www-form-urlencoded, with honeypot protection.
 */
export async function submitReaddyForm(
  form: HTMLFormElement,
  submitAddr: string,
  successMessage: string,
): Promise<FormResult> {
  const formData = new FormData(form);

  const honeypot = String(formData.get('website_alt') ?? '').trim();
  if (honeypot) {
    return { ok: true, message: successMessage };
  }
  formData.delete('website_alt');

  const body = new URLSearchParams();
  formData.forEach((value, key) => {
    body.append(key, typeof value === 'string' ? value : '');
  });

  try {
    const response = await fetch(submitAddr, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });

    const responseText = await response.text();

    let parsed: FormApiResponse | null = null;
    try {
      parsed = JSON.parse(responseText) as FormApiResponse;
    } catch {
      parsed = null;
    }

    const serverMsg =
      parsed?.meta?.message ||
      parsed?.message ||
      parsed?.meta?.detail ||
      responseText ||
      '';
    const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');

    if (response.ok && parsed?.code === 'OK' && !isSpam) {
      return { ok: true, message: successMessage };
    }

    return {
      ok: false,
      message: isSpam
        ? '提交未通过校验，请检查后重试。'
        : serverMsg || '提交失败，请稍后重试。',
    };
  } catch {
    return { ok: false, message: '网络异常，提交失败，请稍后重试。' };
  }
}